import styled from 'styled-components';

export const SpanLabel = styled.span`
  font-weight: bolder;
  color: #777;
`;
